import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Partners() {
  const [ref, vis] = useScrollReveal();

  return (
    <section data-testid="partners-section" className="py-20 sm:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`text-center mb-14 transition-all duration-800 ${vis ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block px-4 py-1.5 bg-[#E8621A]/10 text-[#E8621A] text-xs font-bold tracking-wider uppercase rounded-full mb-4">
            Parcerias
          </span>
          <h2
            data-testid="partners-title"
            className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1A1A2E] mb-4"
            style={{ letterSpacing: '-0.02em' }}
          >
            NOSSOS PARCEIROS
          </h2>
          <div className="w-20 h-1 bg-[#E8621A] mx-auto rounded-full" />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-12 sm:gap-20">
          <div className="transition-all duration-300 hover:scale-105">
            <img
              src="/images/logos/fespapa.png"
              alt="FESPAPA"
              className="h-28 sm:h-36 lg:h-44 w-auto"
              data-testid="partner-fespapa"
            />
            <p className="text-center text-xs text-[#4A5568] mt-3 font-medium">FESPAPA</p>
          </div>
          <div className="transition-all duration-300 hover:scale-105">
            <img
              src="/images/logos/cnpa.png"
              alt="CNPA"
              className="h-28 sm:h-36 lg:h-44 w-auto"
              data-testid="partner-cnpa"
            />
            <p className="text-center text-xs text-[#4A5568] mt-3 font-medium">CNPA</p>
          </div>
        </div>
      </div>
    </section>
  );
}
